import React from 'react';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

export default function Brand() {

  return (
    <div
      className={classnames(`brand flex-column-auto`, styles.brandContainer)}
      id="kt_brand"
    >
      <Link to="" className="brand-logo">
        <div className={styles.logoContainer}>
          <img
            alt="logo"
            src={toAbsoluteUrl('/media/logo/logo-h-black.svg')}
            className={styles.logo}
          />
        </div>
      </Link>
      <img
        src={toAbsoluteUrl('/media/common/Toggle.svg')}
        alt="icon" id="kt_aside_toggle"
        className={styles.toggleButton}
      />
    </div>
  );
}
